import { Component } from "react";
import AppContext from "./AppContext";
import DevToolsBlocker from "../helpers/devToolsBlocker";
import MainChant from "./MainChant";
import UpdateAlert from "../UpdateAlert";
import UpdateDataByRoute from "../helpers/isUpdateDataByRoute";
import AppSetupBalanceNotifications from "./AppSetupBalanceNotifications";
import TicketSystem from "./TicketSystem";
import InstallPWAButton from "./InstallPWAButton";
import NavbarMenu from "./NavbarMenu";
import { FloatButton } from "antd";

class ComponentApp extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
    this.intervalId = null;
  }
  componentDidMount() {
    const { firsrTimeFetchData, setLoadingMenu, setLoadingAccounts } =
      this.context;
    setLoadingMenu();
    setLoadingAccounts(true);
    if (typeof firsrTimeFetchData === "function") {
      setTimeout(async () => {
        await firsrTimeFetchData();
      }, 1500);
    }
    window.addEventListener("scroll", this.scrollFunction);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollFunction);
  }
  scrollFunction = () => {
    // ตรวจสอบระยะ Scroll
    const isScrolled = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;

    // อัปเดต State เพื่อควบคุมการแสดงผล
    if (isScrolled !== this.state.isVisible) this.setState({ isVisible: isScrolled });
  };
  render() {
    const { t, activeAccountData, activeKey, token, openDrawer, isModalOpen, resProfileAdmin, nameMerchang, activeKey1 } = this.context;
    const { handleOk, handleChang, handleReload, handleCancel, history } = this.props;

    const { isVisible } = this.state;
    return (<>

      <NavbarMenu history={history} activeKey={activeKey1} />

      {/* // ป้องกันการเปิด DevTools */}
      <DevToolsBlocker />
      <MainChant />
      <UpdateAlert />
      <UpdateDataByRoute />

      <AppSetupBalanceNotifications
        onClose={handleChang}
        openDrawer={openDrawer}
        activeBank={activeAccountData}
        t={t}
      />
      <TicketSystem
        nameMerchang={nameMerchang}
        isModalOpen={isModalOpen}
        resProfileAdmin={resProfileAdmin}
        handleCancel={handleCancel}
      />

      <InstallPWAButton
        activeKey={activeKey}
        handleReload={handleReload}
        handleChang={handleChang}
        token={token}
        openDrawer={openDrawer}
        isModalOpen={isModalOpen}
        handleOpenModelTicket={handleOk}
      />
      <FloatButton.BackTop type="primary" title={"BackTop"} visibilityHeight={0} style={{ display: isVisible ? "block" : "none", }} />

      <div id="overlay" className="overlay"></div>
    </>);
  }
}

export default ComponentApp;
